import styled from 'styled-components';

const Text = styled.span`
  text-transform: capitalize;
`;

export default Text;
